<template>
    <div
        :id="id"
        class="tl-text-plain"
    >
        <div
            v-if="isExpandable ? !expanded : true"
            class="tl-text-plain-content"
            :class="cssClass"
            v-html="markedContent"
        />
        <div
            v-else
            class="tl-text-plain-content"
            :class="cssClass"
            v-html="markedLongContent"
        />
        <template v-if="isExpandable">
            <div style="height: 8px" />
            <div
                class="expand-icon-wrapper"
                :class="cssClass"
                data-testid="text-plain-expand"
                @click="expanded = !expanded"
            >
                <p>{{ !expanded ? t('expand') : t('hide') }}</p>
                <ArrowRight
                    class="expand-icon"
                    :class="{ active: expanded }"
                    size="6"
                />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import marked from 'widget-components/utilities/marked'
import { computed, ref } from 'vue'
import { useI18n } from 'widget-components/utilities/i18n'
import ArrowRight from 'widget-components/atoms/svg/ArrowRight.vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    content: string
    longContent?: string
    options?: {
        size?: string
        alignment?: string
    }
}>()

const expanded = ref(false)
const isExpandable = computed(() => !!props.longContent)

const { t } = useI18n()

const markedContent = computed(() => marked(props.content))
const markedLongContent = computed(() => marked(props.longContent))

const cssClass = computed(() => {
    const classes = []

    if (props.options?.size) {
        classes.push(props.options.size)
    }

    if (props.options?.alignment) {
        classes.push(props.options.alignment)
    }

    return classes.join(' ')
})
</script>

<style lang="sass" scoped>
@import "./TextPlain.sass"
</style>
